module.exports = __webpack_public_path__ + "static/media/view class discipline.55098c28.svg";